import { matchReportsWidget } from '@sky-it-livedata/livedata-football-widgets';
import { IMatchReportsHome, MatchReportsHome } from '@sky-it-livedata/livedata-sports-design-system';
import React from 'react';

import { IGenericObject } from '../../typings/common-types';
import { getModelFromUseService, isEmptyObject } from '../../utils/props-validator';
import { useService } from '../hooks/useService';

interface IMatchReportsWrapper {
  initialModel: any;
  query: IGenericObject;
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const MatchReportsWrapper = ({ initialModel, live, query }: IMatchReportsWrapper) => {
  const { model } = useService({ live, query, initialValue: initialModel, widget: matchReportsWidget });

  const componentModel: IMatchReportsHome = getModelFromUseService(model);
  return !isEmptyObject(componentModel) ? <MatchReportsHome {...componentModel} /> : null;
};

export default MatchReportsWrapper;
